<template>
    <div v-if="isVisibleOnSmallScreens" class="centered">
        <h1 class="title is-1">This page doesn't exist</h1>
        <br>
        <router-link :to="userHomeLink" class="button is-primary">
            <span class="icon">
                <i class="fa fa-home"></i>
            </span>
            <span>Back to home page</span>
        </router-link>
    </div>
</template>

<script>
    import SmallScreensConfirmationMixin from '../mixins/SmallScreensConfirmation.js'
    import {mapGetters} from 'vuex'

    export default {
        mixins: [SmallScreensConfirmationMixin],

        computed: {
            ...mapGetters(['userHomeLink'])
        }
    }
</script>
